function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.46148 35.9109L77.9741 54.8047C78.2408 54.8762 78.3991 55.1503 78.3276 55.4171L73.1512 74.7356C73.0798 75.0023 72.8056 75.1606 72.5389 75.0891L2.02628 56.1953C1.75955 56.1239 1.60125 55.8497 1.67273 55.583L6.84911 36.2645C6.92058 35.9977 7.19475 35.8394 7.46148 35.9109Z",
  fill: "#27223F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.9512 44.978L44.8609 53.2603C45.1276 53.3317 45.2859 53.6059 45.2144 53.8726L43.6615 59.6682C43.59 59.9349 43.3159 60.0932 43.0491 60.0217L12.1395 51.7395C11.8728 51.6681 11.7145 51.3939 11.7859 51.1272L13.3389 45.3316C13.4103 45.0649 13.6845 44.9066 13.9512 44.978Z",
  fill: "#535285"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.4712 3.20703L75.1768 57.3729C78.132 61.9851 76.8287 68.1161 72.2532 71.1274C67.7494 74.0916 61.6954 72.8435 58.7313 68.3397C58.7093 68.3064 58.6876 68.2729 58.6661 68.2394L23.9605 14.0735L40.4712 3.20703Z",
  fill: "#6F6E98"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M65.7063 67.8296C68.3736 68.5443 71.1153 66.9614 71.83 64.294C72.5447 61.6267 70.9618 58.885 68.2945 58.1703C65.6271 57.4556 62.8855 59.0385 62.1707 61.7058C61.456 64.3732 63.039 67.1149 65.7063 67.8296Z",
  fill: "#27223F",
  stroke: "#8F8EB1"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.1373 58.1621L17.8987 59.9739C18.1655 60.0453 18.3238 60.3195 18.2523 60.5862L17.7347 62.5181C17.6632 62.7848 17.389 62.9431 17.1223 62.8716L10.3608 61.0599C10.0941 60.9884 9.93578 60.7143 10.0072 60.4475L10.5249 58.5157C10.5964 58.2489 10.8705 58.0907 11.1373 58.1621Z",
  fill: "#27223F"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.1373 64.1621L41.8987 65.9739C42.1655 66.0453 42.3238 66.3195 42.2523 66.5862L41.7347 68.5181C41.6632 68.7848 41.389 68.9431 41.1223 68.8716L34.3608 67.0599C34.0941 66.9884 33.9358 66.7143 34.0072 66.4475L34.5249 64.5157C34.5964 64.2489 34.8705 64.0907 35.1373 64.1621Z",
  fill: "#27223F"
});

var SvgLedger = function SvgLedger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLedger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ledger.926e0e29.svg";
export { ForwardRef as ReactComponent };